import React, { useEffect, useState } from 'react';
import { useAddress } from '@thirdweb-dev/react';
import CardDataStats from '../../components/CardDataStats';
import TableOne from '../../components/Tables/TableOne';
import DefaultLayout from '../../layout/DefaultLayout';
import { FaWallet, FaPiggyBank, FaDollarSign, FaCoins } from 'react-icons/fa';
import WalletHistory from './OverView/WalletHistory';

const ECommerce: React.FC = () => {
  const address = useAddress();

  const [walletBalance, setWalletBalance] = useState<string>('0');
  const [totalBalance, setTotalBalance] = useState<string>('0');
  const [defiBalance, setDefiBalance] = useState<string>('0');
  const [nftBalance, setNftBalance] = useState<string>('0');

  const [walletRate, setWalletRate] = useState<string>('0%');
  const [totalRate, setTotalRate] = useState<string>('0%');
  const [defiRate, setDefiRate] = useState<string>('0%');
  const [nftRate, setNftRate] = useState<string>('0%');

  useEffect(() => {
    if (!address) return;

    const fetchMoralisData = async () => {
      try {
        const res = await fetch(`http://localhost:5001/api/demo?address=${address}`);
        const data = await res.json();

        // Native balance from Moralis (ETH as string)
        const native = parseFloat(data.native || '0');

        // Tokens array: e.g. ["USDC: 10.5", "DAI: 5"]
        // Sum tokens balances roughly for DeFi balance:
        let totalTokenValue = 0;
        if (data.tokens && Array.isArray(data.tokens)) {
          data.tokens.forEach((token: string) => {
            // Parse format: "TOKEN_SYMBOL: amount"
            const parts = token.split(':');
            if (parts.length === 2) {
              const amount = parseFloat(parts[1].trim());
              if (!isNaN(amount)) totalTokenValue += amount;
            }
          });
        }

        // NFTs count:
        const nftCount = data.nfts ? data.nfts.length : 0;

        // Update wallet balance & rates with Moralis native balance
        const prevWalletBalance = parseFloat(walletBalance);
        const walletChange = ((native - prevWalletBalance) / (prevWalletBalance || 1)) * 100;
        setWalletBalance(native.toFixed(4));
        setWalletRate(walletChange.toFixed(2) + '%');

        // Example total balance: native + tokens (you can customize this)
        const total = native + totalTokenValue;
        const prevTotalBalance = parseFloat(totalBalance);
        const totalChange = ((total - prevTotalBalance) / (prevTotalBalance || 1)) * 100;
        setTotalBalance(total.toFixed(4));
        setTotalRate(totalChange.toFixed(2) + '%');

        // DeFi balance as total tokens value
        const prevDefiBalance = parseFloat(defiBalance);
        const defiChange = ((totalTokenValue - prevDefiBalance) / (prevDefiBalance || 1)) * 100;
        setDefiBalance(totalTokenValue.toFixed(4));
        setDefiRate(defiChange.toFixed(2) + '%');

        // NFT balance as count
        const prevNftBalance = parseFloat(nftBalance);
        const nftChange = ((nftCount - prevNftBalance) / (prevNftBalance || 1)) * 100;
        setNftBalance(nftCount.toString());
        setNftRate(nftChange.toFixed(2) + '%');
      } catch (error) {
        console.error('Error fetching Moralis wallet data:', error);
      }
    };

    fetchMoralisData();
  }, [address]); // Run when wallet address changes

  return (
    <DefaultLayout>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
        <CardDataStats
          title="Total Balance"
          total={`$${totalBalance}`}
          rate={totalRate}
          levelUp={parseFloat(totalRate) >= 0}
        >
          <FaDollarSign className="text-white" size={22} />
        </CardDataStats>
        <CardDataStats
          title="Wallet Balance"
          total={`${walletBalance} ETH`}
          rate={walletRate}
          levelUp={parseFloat(walletRate) >= 0}
        >
          <FaWallet className="text-white" size={20} />
        </CardDataStats>
        <CardDataStats
          title="DeFi Balance"
          total={`${defiBalance}`}
          rate={defiRate}
          levelUp={parseFloat(defiRate) >= 0}
        >
          <FaPiggyBank className="text-white" size={22} />
        </CardDataStats>
        <CardDataStats
          title="NFT Balance"
          total={`${nftBalance}`}
          rate={nftRate}
          levelUp={parseFloat(nftRate) >= 0}
        >
          <FaCoins className="text-white" size={22} />
        </CardDataStats>
      </div>

      <div className="mt-4 grid gap-4 grid-cols-1">
        <div className="col-span-1 w-full overflow-x-auto sm:overflow-x-hidden">
          <TableOne />
        </div>
        <div className="col-span-1 w-full overflow-x-auto sm:overflow-x-hidden">
          <WalletHistory />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default ECommerce;













